import React from "react";
import { LoadingSpinnerWembii } from "../component/LoadingSpinnerWembii";
import "./CheckingConnection.scss";

export const CheckingConnection = () => {
  return (
    <div className="checking-connection-page">
      <div className="checking-connection-page__ambient" aria-hidden />
      <div className="checking-connection-page__shell">
        <LoadingSpinnerWembii active size="lg" />
        <h1 className="checking-connection-page__title">Comprobando conexión</h1>
        <p className="checking-connection-page__text">
          Esto puede tardar un momento; por favor espera…
        </p>
      </div>
    </div>
  );
};
